import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { LOCALES } from '../utils/constants';
import { swedish } from './lang/sv-se';
import { english } from './lang/en-us';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      [LOCALES.EN_US]: english,
      [LOCALES.SV_SE]: swedish,
    },
    fallbackLng: LOCALES.EN_US,
    lowerCaseLng: true,
    debug: false,
    lng: LOCALES.EN_US, // default lang
    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: false,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
